import { paths } from "helpers/paths";
import React, { useEffect } from "react";
import { Route, Switch } from "react-router-dom";
import * as source from "sources/books/postamatPoints";
import Form from "./form";
import List from "./list";

export default function PostamatPoints(props) {
    useEffect(() => {
        return () => props.clearParams("postamat-points");
    }, []);

    const { match, location, history } = props;
    const back = () => history.push(match.path);
    return (
        <div className="page-content">
            <Switch location={location}>
                <Route
                    path={paths.postamatPointsShow("new")}
                    render={(rest) => <Form {...rest} transition="full" title="Постамат" back={back} source={source} />}
                />
                <Route
                    path={paths.postamatPointsShow(":id")}
                    render={(rest) => <Form {...rest} transition="full" title="Постамат" back={back} source={source} />}
                />
                <Route
                    path={paths.postamatPoints}
                    render={() => (
                        <List
                            {...props}
                            transition="full"
                            createBtnText="Создать постамат"
                            title="Постаматы"
                            nofilter
                            source={source}
                        />
                    )}
                />
            </Switch>
        </div>
    );
}
